import React, { useCallback, useEffect, useState } from 'react';
import Address from './Address';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { winnreAuth } from '../../../../utils/axios';
import { toast } from 'react-toastify';
import SkeletonDeal from '../../../../Components/Molecules/Skeleton/SkeletonDeal';
import { toIndianRs, toNumberFormat } from '../../../../helpers';
import { LoadingSpinner } from '../../../../Components/Molecules/LoadingUI';

import GrClose from '@meronex/icons/gr/GrClose';
import Modal from '../../../../Components/Organisms/Modal';
import useData from './data';
import useInput from '../../../../Hooks/useInput';
import { RE_NAME, RE_Pin, RE_Phone } from '../../../../constants';
import useBookingSummary from '../../../../Hooks/use-bookingSummary';
import BsArrowLeft from '@meronex/icons/bs/BsArrowLeft';
import { usePhoneInput } from '../../../../Hooks';
import LoadingButton from '../../../../Components/Organisms/LoadingButton';
import { getConfig } from '../../../../utils/config';
import Bag from './Bag';
import DealSection from '../DealSection';
import BasketFull from '../BasketFull';

let interval = null;

function Checkout() {
    const params = useParams();
    const [currentStep, setCurrentStep] = useState(1);
    const history = useHistory();
    const userHash = useSelector((state) => state.auth.userHash);
    const rewardPoints = useSelector((state) => state.auth.rewardPoints);
    // const [otp, setOtp] = useState(['', '', '', '']);
    const [isFormValid, setIsFormValid] = useState(false);
    const [amountPayable, setAmountPayable] = useState(0);
    const [totalRedeem, settotalRedeem] = useState(0);
    const [termsCheckbox, setTermsCheckbox] = useState(false);
    const [loading, setLoading] = useState(false);
    const [redirecting, setRedirecting] = useState(false);
    // const[status,setStatus]=useState(true);
    const [otp, setOtp] = useState('');

    const config = getConfig();

    const handleOnChange = () => {
        setTermsCheckbox(!termsCheckbox);
    };
    // Cart Counter
    const [cartAmount, setCartAmount] = useState(0);
    const [cartPoint, setCartPoint] = useState(0);
    const [shippingFee, setShippingFee] = useState(0);
    const [platformFee, setPlatformFee] = useState(0);
    const [cartItems, setCartItems] = useState(0);
    const [cartValue, setCartValue] = useState([]);
    const {
        deals,
        loadingDeal,
        showOtpModal,
        setShowOtpModal,
        getOtp,
        otpLoading,
        timeLeftToResend,
        setTimeLeftToResend,
        getOffers
        // userAccountSummary,
    } = useData(userHash, params.dealId, otp, setOtp, cartAmount);

    //   Handle input change
    const handleChange = (e) => {
        const value = e.target.value;

        if (/^\d{0,4}$/.test(value)) {
            setOtp(value);
        }
    };
    console.log('otp', otp);

    const { userAccountSummary } = useBookingSummary();
    const [hideError, setHideError] = useState(true);
    const [points, setPoints] = useState(0);
    const [redeemPointsLimit, setRedeemPointsLimit] = useState(0);
    const [error, setError] = useState(null);

    const [formData, setFormData] = useState({
        address: '',
        locality: '',
        city: '',
        state: ''
    });
    const {
        value: name,
        isValid: nameIsValid,
        hasError: nameHasError,
        valueChangeHandler: nameChangedHandler,
        inputBlurHandler: nameBlurHandler,
        reset: resetName
    } = useInput((value) => !RE_NAME.test(value) && value !== '');

    const {
        value: Pin,
        isValid: PinIsValid,
        hasError: PinHasError,
        valueChangeHandler: PinChangedHandler,
        inputBlurHandler: PinBlurHandler,
        reset: resetPin
    } = useInput((value) => RE_Pin.test(value));
    const {
        value: phoneNumber,
        isValid: phoneNumberIsValid,
        hasError: phoneHasError,
        valueChangeHandler: phoneChangedHandler,
        inputBlurHandler: phoneBlurHandler,
        reset: resetPhone
    } = useInput(
        (value) => RE_Phone.test(value),
        undefined,
        hideError,
        setHideError
    );

    const {
        state: {
            isValid: mobileNumberIsValid,
            mobile,
            country,
            mobileHasError,
            isInputFocused,
            isInternationalCustomer
        },
        onChange,
        validator,
        setIsTouched,
        setMobile,
        getMobileWithoutCountryCode,
        setInputFocused,
        setIsInternationalCustomer
    } = usePhoneInput();

    console.log('mobile', mobile);
    console.log('mobileNumber', getMobileWithoutCountryCode());
    console.log('countryCode', country.dialCode);
    console.log('phoneNumber', phoneNumber);
    console.log('currentStep', currentStep);

    useEffect(() => {
        const timer = setTimeout(() => {
            setError(null);
        }, 3000);

        return () => {
            clearTimeout(timer);
        };
    }, [error]);

    useEffect(() => {
        let isValid = false;
        setIsFormValid(isValid);

        if (
            nameIsValid &&
            mobileNumberIsValid &&
            PinIsValid &&
            formData.address &&
            formData.locality &&
            formData.city &&
            formData.state
        ) {
            isValid = true;
            setIsFormValid(isValid);
        }
    }, [
        formData.address,
        formData.state,
        formData.locality,
        name,
        mobile,
        Pin
    ]);
    console.log('formIsValid', isFormValid);

    const startTimer = useCallback(() => {
        interval = setInterval(() => {
            if (timeLeftToResend >= 1) {
                setTimeLeftToResend((prevState) => prevState - 1);
            } else if (timeLeftToResend < 1) {
                setTimeLeftToResend(0);
            }
        }, 1000);
    }, [timeLeftToResend]);

    useEffect(() => {
        if (timeLeftToResend < 1 && interval) {
            clearInterval(interval);
        }
        if (timeLeftToResend === 59) {
            if (interval) {
                clearInterval(interval);
            }
            startTimer();
        }
    }, [timeLeftToResend]);

    useEffect(() => {
        // Function to update cart count from localStorage
        const updateCartCount = () => {
            if (localStorage.getItem('cartData')) {
                const cartData = JSON.parse(localStorage.getItem('cartData'));
                setCartAmount(cartData ? cartData.totalMrp : 0);
                setCartItems(cartData ? cartData.totalProduct : 0);
                setShippingFee(cartData ? cartData.totalShippingFee : 0);
                setCartPoint(cartData ? cartData.totalPoints : 0);
                setPlatformFee(cartData ? 99 : 0);
                getOffers();
                if (cartData.totalMrp > 0) {
                    setCartValue(cartData.cartValues);
                    console.log('cartVa', cartValue);
                } else {
                    clearCartvalue();
                }
            } else {
                clearCartvalue();
            }
        };

        // Initial count load
        updateCartCount();

        // Listen for the custom 'cartUpdated' event
        window.addEventListener('cartUpdated', updateCartCount);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('cartUpdated', updateCartCount);
        };
    }, []);

    const clearCartvalue = () => {
        setCartAmount(0);
        setCartValue([]);
        setShippingFee(0);
        setPlatformFee(0);
        history.push('/rewardStore');
    };
    const handleSubmit = () => {
        setLoading(true);
        console.log(formData);
        // const otpString = otp.join('');

        const dealIds = cartValue.map((deal) => deal.id).join(',');
        const pointsRedeemed = cartValue.reduce(
            (total, deal) => total + deal.points,
            0
        );

        winnreAuth({
            method: 'POST',
            url: `/winnre/user/deals/reward-redeem?otp=${otp}&dealIds=${dealIds}&pointsRedeemed=${pointsRedeemed}&mobileNumber=${getMobileWithoutCountryCode()}&amountToBePaid=${
                shippingFee + 99
            }&customerName=${name}&countryCode=${
                country.dialCode
            }&alternateMobileNumber=${phoneNumber}`,
            data: {
                address: formData.address,
                city: formData.city,
                country: 'India',
                line1: formData.address,
                line2: formData.address,
                streetAddress: '',
                microMarket: '',
                pincode: Pin,
                subregion: formData.locality,
                state: formData.state
            }
        })
            .then((res) => {
                // setStatus(true);
                window?.webengage?.track('RewardsOTPSubmitted', {
                    Status: res.status
                });
                console.log('Resp', res);
                setLoading(false);
                if (res.status === 'SUCCESS') {
                    // window?.webengage?.track('PaymentGatewayInvoked', {
                    //     DealID: deal?.id,
                    //     Amount: amountPayable,
                    //     PointsRedeemed: points,
                    //     OfferName: deal?.title,
                    //     BrandName: deal?.vendor?.name,
                    //     Category: deal?.category?.name,
                    //     Tags: `${deal?.tags?.map((tag) => tag?.name)}`
                    // });
                    setRedirecting(true);
                    window.location.href = res.message;
                    localStorage.removeItem('cartData');
                } else {
                    setError(res?.message);
                }
            })
            .catch((err) => {
                console.log(err);
                setError('Something went wrong. Please try again');
            });
    };

    const getConditionalStep = () => {
        switch (currentStep) {
            case 1:
                return <Bag cartValue={cartValue} />;
            case 2:
                return (
                    <Address
                        cartValue={cartValue}
                        formData={formData}
                        setFormData={setFormData}
                        name={name}
                        nameChangedHandler={nameChangedHandler}
                        nameBlurHandler={nameBlurHandler}
                        nameHasError={nameHasError}
                        nameIsValid={nameIsValid}
                        Pin={Pin}
                        PinChangedHandler={PinChangedHandler}
                        PinHasError={PinHasError}
                        PinBlurHandler={PinBlurHandler}
                        PinIsValid={PinIsValid}
                        phoneNumber={phoneNumber}
                        phoneChangedHandler={phoneChangedHandler}
                        phoneBlurHandler={phoneBlurHandler}
                        phoneHasError={phoneHasError}
                        phoneNumberIsValid={phoneNumberIsValid}
                        mobileNumberIsValid={mobileNumberIsValid}
                        mobile={mobile}
                        setMobile={setMobile}
                        mobileHasError={mobileHasError}
                        onChange={onChange}
                        validator={validator}
                        setIsTouched={setIsTouched}
                        setInputFocused={setInputFocused}
                    />
                );

            default:
                return (
                    <Bag cartValue={cartValue} />
                    // <Address
                    //     deal={deal}
                    //     formData={formData}
                    //     setFormData={setFormData}
                    //     name={name}
                    //     nameChangedHandler={nameChangedHandler}
                    //     nameBlurHandler={nameBlurHandler}
                    //     nameHasError={nameHasError}
                    //     nameIsValid={nameIsValid}
                    //     Pin={Pin}
                    //     PinChangedHandler={PinChangedHandler}
                    //     PinHasError={PinHasError}
                    //     PinBlurHandler={PinBlurHandler}
                    //     PinIsValid={PinIsValid}
                    //     phoneNumber={phoneNumber}
                    //     phoneChangedHandler={phoneChangedHandler}
                    //     phoneBlurHandler={phoneBlurHandler}
                    //     phoneHasError={phoneHasError}
                    //     phoneNumberIsValid={phoneNumberIsValid}
                    //     mobileNumberIsValid={mobileNumberIsValid}
                    //     mobile={mobile}
                    //     setMobile={setMobile}
                    //     mobileHasError={mobileHasError}
                    //     onChange={onChange}
                    //     validator={validator}
                    //     setIsTouched={setIsTouched}
                    //     setInputFocused={setInputFocused}
                    // />
                );
        }
    };
    const handleBackClick = () => {
        if (currentStep === 2) {
            setCurrentStep(1);
        } else {
            history.goBack();
        }
        // history.goBack();
    };

    const handleTermsClick = () => {
        history.push('/terms-and-conditions', { scrollTo: 'rewardsTerms' });
    };

    const placeOrder = () => {
        window?.webengage?.track('PlaceOrderClicked', {
            CartTotal: `${cartAmount}`,
            Quantity: `${cartItems}`,
            PlatformFee: '99',
            ShippingFee: `${shippingFee}`,
            AmountPayable: `${shippingFee + 99}`
        });

        setCurrentStep(currentStep + 1);
    };
    console.log('CART POINTS', cartPoint);
    return (
        <div>
            <div className=" mt-4 lg:mt-8">
                <div
                    onClick={handleBackClick}
                    className="flex items-start pl-4 lg:pl-10 cursor-pointer "
                >
                    <BsArrowLeft className="text-black w-6 h-full" />
                </div>

                <div className="flex justify-center items-center mb-8 mt-2 lg:-mt-7">
                    <h1 className=" text-base md:text-lg font-semibold tracking-wide text-gray-600">
                        <span
                            className={
                                currentStep === 1
                                    ? 'text-primary'
                                    : 'font-bold text-black'
                            }
                        >
                            SHOPPING CART
                        </span>
                        <span className="mx-3 text-gray-400">----------</span>
                        <span
                            className={
                                currentStep === 2
                                    ? 'text-primary'
                                    : currentStep > 2
                                    ? 'font-bold text-black'
                                    : 'text-[#908F95]'
                            }
                        >
                            CHECKOUT
                        </span>
                        {/* <span className="mx-3 text-gray-400">-------</span>
                        <span
                            className={
                                currentStep === 2
                                    ? 'text-primary'
                                    : 'text-[#908F95]'
                            }
                        >
                            PAYMENT
                        </span> */}
                    </h1>
                </div>
            </div>
            {!loadingDeal && currentStep != 1 && (
                <div className="flex flex-col items-center ">
                    <div className="flex flex-col gap-2 justify-between w-[90%] lg:w-[60%] max-w-6xl px-4 lg:py-4 pb-2 mb-4  pb-6 border-2 border-gray-200 rounded-lg shadow-sm">
                        <h1 className="font-bold text-base">Product Details</h1>
                        <div
                            className={`${
                                cartValue?.length > 3 &&
                                'grid md:grid-cols-2 md:gap-x-10'
                            } max-h-[30vh] overflow-y-scroll scrollbar-thin lg:scrollbar-hide `}
                        >
                            {cartValue.map((deal, index) => (
                                <div className="flex flex-row gap-6 lg:items-center pt-4 py-2 lg:py-4 border-b border-gray-200">
                                    <img
                                        className="w-24 h-24 lg:w-20 lg:h-20 object-cover "
                                        // src={deal?.displayImage?.url}
                                        src={
                                            deal?.thumbnailImageUrl
                                                ? deal?.thumbnailImageUrl
                                                : deal?.displayImageUrl
                                        }
                                    />

                                    <div className="flex flex-col gap-2">
                                        <div className="flex items-center">
                                            <div>
                                                <h4 className="text-sm font-bold">
                                                    {deal?.title}
                                                </h4>
                                            </div>
                                        </div>

                                        <div className="flex items-center gap-3">
                                            <p className="text-primary text-base font-bold">
                                                {toIndianRs(deal?.productMrp)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {
                /* !loadingDeal && */ <div className="flex flex-col items-center ">
                    <div className="flex lg:flex-row  flex-col justify-between w-[90%] lg:w-[60%] max-w-6xl px-4 lg:py-4 pt-2  pb-6 border-2 border-gray-200 rounded-lg shadow-sm">
                        <div className="lg:w-[50%] w-full">
                            {getConditionalStep()}
                        </div>

                        <div className="lg:border-l-2 border-b-2 border-gray-200 -mx-4 lg:mx-0 lg:-my-4"></div>
                        {currentStep === 1 && (
                            <div className="lg:w-[40%] w-full">
                                <h1 className="font-bold text-lg mt-4 lg:mt-0 pb-2">
                                    Product Details
                                </h1>
                                <div className="flex justify-between text-sm mb-2">
                                    <h4 className="text-[#908F95]">
                                        {/* Price MRP */}
                                        Total MRP
                                    </h4>
                                    <h4 className="font-medium text-sm line-through">
                                        {toIndianRs(cartAmount)}
                                    </h4>
                                </div>
                                <div className="flex justify-between text-sm mb-2">
                                    <h4 className="text-[#908F95]">
                                        {/* Platform Fee{' '} */}
                                        Selling Price{' '}
                                    </h4>
                                    <h4 className="text-green-500 text-sm font-semibold">
                                        {toIndianRs(99)}
                                    </h4>
                                </div>
                                <div className="flex justify-between text-sm mb-2">
                                    <h4 className="text-[#908F95]">
                                        Shipping Fee{' '}
                                    </h4>
                                    {shippingFee > 0 && (
                                        <h4 className="text-green-500 text-sm font-semibold">
                                            {toIndianRs(shippingFee)}
                                        </h4>
                                    )}
                                    {shippingFee === 0 && (
                                        <h4 className="text-green-500 text-sm font-semibold">
                                            FREE
                                        </h4>
                                    )}
                                </div>
                                <hr className="mx-4 my-4 border-b-[2px] border-gray-100" />
                                <div className="flex justify-between font-bold mt-4">
                                    <h4>Amount Payable</h4>

                                    <h4>{toIndianRs(shippingFee + 99)}</h4>
                                </div>
                                <button
                                    className={` bg-blue-600 hover:bg-blue-700 text-white w-full py-3 rounded mt-6 cursor-pointer `}
                                    onClick={placeOrder}
                                >
                                    Place Order
                                </button>
                            </div>
                        )}

                        {currentStep != 1 && (
                            <div className="lg:w-[40%] w-full">
                                <div className="flex flex-col gap-4">
                                    {/* <div className="flex flex-col lg:flex-row gap-6 lg:items-center pt-4 lg:py-4">
                                    <img
                                        className="h-28 w-40 rounded-md"
                                        src={deal?.displayImage?.url}
                                    />

                                    <div className="flex flex-col gap-2">
                                        <div className="flex items-center">
                                            <div>
                                                <h4 className="text-base font-bold">
                                                    {deal?.title}
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                    {/* <hr className="mx-4 my-4 border-b-[2px] border-gray-100" /> */}
                                    <div>
                                        <h1 className="font-bold text-base mb-4 mt-4 lg:mt-0">
                                            Payment Details
                                        </h1>

                                        <div className="flex justify-between mb-2">
                                            <h4 className="text-[#908F95] text-sm">
                                                {/* Price MRP */}
                                                Total MRP
                                            </h4>
                                            <h4 className="font-medium text-sm line-through">
                                                {toIndianRs(cartAmount)}
                                            </h4>
                                        </div>
                                        <div className="flex justify-between text-sm mb-2">
                                            <h4 className="text-[#908F95] text-sm">
                                                {/* Platform Fee{' '} */}
                                                Selling Price{' '}
                                            </h4>
                                            <h4 className="text-green-500 text-sm font-semibold">
                                                {toIndianRs(99)}
                                            </h4>
                                        </div>
                                        <div className="flex justify-between text-sm mb-2">
                                            <h4 className="text-[#908F95]">
                                                Shipping Fee{' '}
                                            </h4>
                                            {shippingFee > 0 && (
                                                <h4 className="text-green-500 text-sm font-semibold">
                                                    {toIndianRs(shippingFee)}
                                                </h4>
                                            )}
                                            {shippingFee === 0 && (
                                                <h4 className="text-green-500 text-sm font-semibold">
                                                    FREE
                                                </h4>
                                            )}
                                        </div>

                                        <hr className="mx-4 my-4 border-b-[2px] border-gray-100" />
                                        <div className="flex justify-between font-bold mt-4">
                                            <h4>Amount Payable</h4>

                                            <h4>
                                                {toIndianRs(shippingFee + 99)}
                                            </h4>
                                        </div>

                                        {currentStep === 2 && (
                                            <LoadingButton
                                                disabled={
                                                    currentStep === 2 &&
                                                    !isFormValid
                                                }
                                                className={` bg-[#16519E] text-white w-full py-3 rounded mt-6 cursor-pointer
                   ${
                       currentStep === 2 && !isFormValid
                           ? 'bg-blue-600 text-white opacity-75 cursor-not-allowed'
                           : 'bg-blue-600 hover:bg-blue-700'
                   }  `}
                                                onClick={getOtp}
                                                loading={
                                                    otpLoading &&
                                                    currentStep === 2
                                                }
                                            >
                                                Proceed to Checkout
                                            </LoadingButton>
                                        )}
                                        <p className="mt-1 text-sm">
                                            Once you redeem, your item will be
                                            processed for delivery within 10
                                            business days based on your location
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    {currentStep === 1 && (
                        <>
                            {/* FIROZ */}
                            {userAccountSummary?.rewardPoints +
                                userAccountSummary?.unInvoicedCommission >
                                cartPoint && deals?.length > 0 ? (
                                <div className="px-4 py-5 lg:p-5">
                                    <p className="mb-4 mt-4 text-xl text-primary font-semibold px-1 lg:px-0">
                                        {' '}
                                        You have more rewards to redeem
                                    </p>

                                    {deals.length > 0 && (
                                        <DealSection
                                            type={' '}
                                            offers={deals.slice(0, 3)}
                                            isRewards={true}
                                        />
                                    )}
                                    <button
                                        onClick={() =>
                                            history.push('/rewardStore')
                                        }
                                        className="flex items-center justify-center gap-x-2 mx-auto px-4 py-2 text-[#908F95] border-[3px] border-[#DDDDDD] rounded mb-6 mt-8"
                                    >
                                        View More Rewards
                                    </button>
                                </div>
                            ) : (
                                <div className="w-full">
                                    <BasketFull
                                        isCheckout
                                        placeOrder={placeOrder}
                                    />
                                </div>
                            )}
                        </>
                    )}
                    <Modal
                        visible={showOtpModal}
                        className={`w-[98%] md:w-[50%] lg:w-[40%] xl:w-[30%]`}
                    >
                        {loading && !redirecting && (
                            <div className="h-[30vh] flex flex-col justify-center items-center py-1">
                                <div className="">
                                    <LoadingButton
                                        hideButton={true}
                                        loading={loading}
                                    />
                                </div>
                                <div className="mt-4">
                                    <p className="text-sm text-[#16519E] mt-2 leading-4 px-10 text-center">
                                        Upon successful verification of the OTP,
                                        you will be redirected to a payment page
                                        powered by Reloy. Your order will be
                                        processed upon successful payment.
                                    </p>
                                </div>
                            </div>
                        )}

                        {!loading && !redirecting && (
                            <>
                                <div className="flex justify-end px-4 pt-6 cursor-pointer">
                                    <GrClose
                                        onClick={() => setShowOtpModal(false)}
                                        className={` h-5 w-5 cursor-pointer `}
                                    />
                                </div>
                                <div className="flex flex-col pt-4 pb-8 justify-center">
                                    <div className=" text-center">
                                        <h2 className="text-xl font-bold mb-2">
                                            Claim your Reward
                                        </h2>
                                        <p className="text-sm mt-2 mb-2 text-[#16519E]">
                                            You are redeeming products against
                                            your referral rewards. Please note
                                            that once an order is placed, it
                                            cannot be canceled.
                                        </p>
                                        <hr className=" w-1/2 h-1 bg-gray-300 my-4 mx-auto border-2" />
                                        <div className="px-5">
                                            <p className="text-gray-600 mb-6 px-3">
                                                Verify your mobile number to
                                                claim. We have sent an OTP to
                                                your registered mobile
                                                number/email.
                                            </p>
                                            <div className=" flex items-start mb-4">
                                                <input
                                                    type="text"
                                                    value={otp}
                                                    onChange={handleChange}
                                                    maxLength="4"
                                                    autoComplete="one-time-code"
                                                    inputMode="numeric"
                                                    className="w-full h-12 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-300 text-lg pl-2"
                                                    placeholder="Enter OTP"
                                                />
                                            </div>
                                            <div className="flex items-start mb-4">
                                                {timeLeftToResend > 0 ? (
                                                    <b className="">
                                                        Resend again in 00:
                                                        {timeLeftToResend < 10
                                                            ? '0' +
                                                              timeLeftToResend
                                                            : timeLeftToResend}
                                                    </b>
                                                ) : (
                                                    <b
                                                        className="font-semibold cursor-pointer"
                                                        onClick={getOtp}
                                                    >
                                                        Resend OTP ?
                                                    </b>
                                                )}
                                            </div>
                                            <div className="flex my-1">
                                                <input
                                                    type="checkbox"
                                                    checked={termsCheckbox}
                                                    onChange={handleOnChange}
                                                    className="checkbox-sm bg-white rounded-md border-gray-100 checked:bg-blue-600"
                                                    autoComplete="off"
                                                />
                                                <p className={` mx-2 text-sm `}>
                                                    <span>I agree to the</span>
                                                    <span
                                                        onClick={
                                                            handleTermsClick
                                                        }
                                                        className="font-semibold text-primary cursor-pointer"
                                                    >
                                                        {` Terms & Conditions`}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>

                                        <div className="px-5 mt-4 ">
                                            <button
                                                onClick={handleSubmit}
                                                className={`bg-[#16519E] text-white w-full py-2 rounded-md transition duration-200 ${
                                                    !termsCheckbox ||
                                                    otp.length < 4
                                                        ? 'cursor-not-allowed opacity-50'
                                                        : 'cursor-pointer '
                                                }`}
                                                disabled={
                                                    !termsCheckbox ||
                                                    otp.length < 4
                                                }
                                            >
                                                Submit
                                            </button>
                                        </div>

                                        <p className="text-sm text-[#16519E] mt-1 leading-4 px-10">
                                            Once your OTP is verified, you'll be
                                            redirected to the Reloy-powered
                                            payment page. Your order will be
                                            processed after successful payment.
                                        </p>
                                        {error && (
                                            <div class="alert alert-error  mx-8 animate-pulse h-auto mt-2 ">
                                                <label>{error}</label>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                    </Modal>
                </div>
            }
        </div>
    );
}

export default Checkout;
